import React, { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import TitleHeader from './titleHeader';
import ModalAddress from "../Components/modalAddress";
import imageUser from "../Resources/svg/image-user.svg";
import { addWorkData } from "../Store/simulate/actions";
import ErrorCustom from "../Components/errorCustom";
import { validatePhone, validateEmail, validateNumberField, validateTextOnlyAlphanumeric } from "../Utils/validators";
import useBeforeFirstRender from '../customHook/useBeforFirstRender';
import ListAddresses from "../Components/FormElements/listAddresses";
import Step from "../Components/FormElements/step";

export default function WorkData() {
  const dataStore = useSelector(state => state.simulate.policy.workData);
  const dispatch = useDispatch();
  const history = useHistory();
  const { register, errors, handleSubmit } = useForm();
  const dataClient = useSelector(state => state.simulate.policy.client);
  const client = dataClient.datosCliente;

  const [data, setData] = useState({situation: 'Dependiente'});
  const [isRetired, setIsRetired] = useState(false);
  const [open, setOpen] = useState(false);
  const [address, setAddress] = useState({});
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (Object.keys(dataStore).length > 0 ) {
      setData(dataStore);
      setAddress(dataStore.address || {});
    }
  }, []);

  const navigationPrev = () => {
    history.push('/simulaciones/datos-cliente');
  };

  const navigationNext = () => {
    history.push('/simulaciones/declaracion-de-salud');
  };

  const handleSituation = (e) => {
    const { value } = e.target;
    setIsRetired(value === 'Jubilado');
  };

  const onSubmit = data => {
    if (!isRetired && Object.keys(address).length === 0) {
      setErrorMessage('Agregue una dirección.');
      return false;
    } else {
      setErrorMessage('');
    }
    const dataWork = {
      ...data,
      address,
    };
    dispatch(addWorkData(dataWork));
    navigationNext();
  };

  useBeforeFirstRender(client);

  return (
    <div className="container">
      <div className="workData">
        <div className="column">
          <Step handleClick={() => navigationPrev()} step="2" total="7"/>
            <TitleHeader 
              title="Datos"
              titleBold="laborales"
              subtitle="Para poder asegurarlo necesitamos la siguiente información"
            />
          <form className="workData__form" onSubmit={handleSubmit(onSubmit)}>
            <p className="textGroup">¿Cuál es su situación laboral?</p>
            <div className="workData__form__item">
              <p>
                <label>
                  <input 
                    className="with-gap" 
                    name="situation" 
                    id="dependent"
                    type="radio" 
                    value="Dependiente"
                    ref={register()}
                    onChange = {e => handleSituation(e)}
                    defaultChecked={data.situation === 'Dependiente'}
                    />
                  <span>Dependiente</span>
                </label>
              </p>
              <p>
                <label>
                  <input 
                    className="with-gap" 
                    name="situation" 
                    id="independent"
                    value="Independiente"
                    ref={register()}
                    onChange = {e => handleSituation(e)}
                    defaultChecked={data.situation === 'Independiente'}
                    type="radio" />
                  <span>Independiente</span>
                </label>
              </p>
              <p>
                <label>
                  <input 
                    className="with-gap" 
                    name="situation" 
                    id="retired"
                    value="Jubilado"
                    ref={register()}
                    onChange = {e => handleSituation(e)}
                    defaultChecked={data.situation === 'Jubilado'}
                    type="radio" />
                  <span>Jubilado</span>
                </label>
              </p>
            </div>
            {!isRetired && 
              <div className="">
                <div className="workData__form__item input-field">
                  <input 
                    type="text"
                    className={errors.companyName ? 'error' : ''}
                    autoComplete="off"
                    name="companyName"
                    id="companyName"
                    maxLength="50"
                    ref={register({ validate: validateTextOnlyAlphanumeric })}
                    defaultValue={data.companyName || ''}
                  />
                  <label className={data.companyName ? 'active' : ''} htmlFor="companyName">Razon social de la empresa</label>
                  <ErrorCustom errors={errors} name="companyName" />
                </div>
                <div className="workData__form__item input-field">
                  <input 
                    type="text"
                    className={errors.companyGyre ? 'error' : ''}
                    autoComplete="off"
                    maxLength="50"
                    ref={register({ validate: validateTextOnlyAlphanumeric })}
                    id="companyGyre"
                    name="companyGyre"
                    defaultValue={data.companyGyre || ''}
                  />
                  <label className={data.companyGyre ? 'active' : ''} htmlFor="companyGyre">Giro de la empresa</label>
                  <ErrorCustom errors={errors} name="companyName" />
                </div>
                <div className="workData__form__item input-field">
                  <input 
                    type="text"
                    className={errors.position ? 'error' : ''}
                    autoComplete="off"
                    maxLength="50"
                    ref={register({ validate: validateTextOnlyAlphanumeric })}
                    id="position"
                    name="position"
                    defaultValue={data.position || ''}
                  />
                  <label className={data.position ? 'active' : ''} htmlFor="position">Cargo que ocupa</label>
                  <ErrorCustom errors={errors} name="companyName" />
                </div>
                <div className="workData__form__item input-field">
                  <input 
                    type="text"
                    className={errors.yearsOfService ? 'error' : ''}
                    autoComplete="off"
                    id="yearsOfService"
                    name="yearsOfService"
                    maxLength="3"
                    ref={register({ validate: validateNumberField })}
                    defaultValue={data.yearsOfService || ''}
                  />
                  <label className={data.yearsOfService ? 'active' : ''} htmlFor="yearsOfService">Años de servicio</label>
                  <ErrorCustom errors={errors} name="yearsOfService" />
                </div>
                <div className="workData__form__item salary">
                  <select 
                    name="currency"
                    ref={register()}
                    maxLength="15"
                    defaultValue={data.currency || 'PEN'}
                  >
                    <option value="PEN">PEN</option>
                    <option value="USD">USD</option>
                  </select>
                  <div className="input-field">
                    <input 
                      type="text"
                      className={errors.salary ? 'error' : ''}
                      autoComplete="off"
                      id="salary"
                      name="salary"
                      maxLength="15"
                      ref={register({ validate: validateNumberField })}
                      defaultValue={data.salary || ''}
                    />
                    <label className={data.salary ? 'active' : ''} htmlFor="salary">Ingresos totales al mes</label>
                    <ErrorCustom errors={errors} name="salary" />
                  </div>
                </div>
                <p className="textGroup">Datos de contacto</p>
                <div className="workData__form__item input-field">
                  <input 
                    type="text"
                    className={errors.phone ? 'error' : ''}
                    autoComplete="off"
                    id="phone"
                    name="phone"
                    maxLength="15"
                    ref={register({ validate: validatePhone })}
                    defaultValue={data.phone || ''}
                  />
                  <label className={data.phone ? 'active' : ''} htmlFor="phone">Número de teléfono laboral</label>
                  <ErrorCustom errors={errors} name="phone" />
                </div>
                <div className="workData__form__item input-field">
                  <input 
                    type="text"
                    className={errors.email ? 'error' : ''}
                    autoComplete="off"
                    id="email"
                    name="email"
                    ref={register({ validate: validateEmail })}
                    defaultValue={data.email || ''}
                    maxLength="95"
                  />
                  <label className={data.email ? 'active' : ''} htmlFor="email">Correo electrónico laboral</label>
                  <ErrorCustom errors={errors} name="email" />
                </div>
                <p className="textGroup">Ingrese su dirección laboral</p>
                
                <ListAddresses address={address} setAddress={setAddress} setOpen={setOpen} />
                {errorMessage !== '' && 
                  <p className="error"> {errorMessage} </p>
                }
              </div>
            }
            <div className="contentButton">
              <button
                type="submit" 
                className="buttonCustom md"
                >Continuar</button>
            </div>
          </form>
        </div>
        <div className="column-image">
          <img src={imageUser}/> 
        </div>
      </div>
      <ModalAddress 
        setAddress={setAddress}
        open={open}
        setOpen={setOpen}
      />
    </div>
  );
}
